import { computePositionAppliedFor, jobZodRefinement, validatePositionAppliedFor } from "../generated/dbs-rules"

// The job-role rules live in the consolidated rule set (DBS-344): PositionAppliedFor's character set and length, and
// the barred-list and working-at-home flags that need an Enhanced application (DBS codes 123-125). Generated into
// src/generated/dbs-rules by api/scripts/sync_dbs_rules.sh; the api runs the same rules.
export { computePositionAppliedFor, validatePositionAppliedFor }

export const rulesAddJob = jobZodRefinement()
